import { graphqlClient } from "../../../client";
import mutationDocument from "./updateContactBirthDateMutation.graphql";
import type { InputUpdateContactBirthDateType, Mutations, MutationsUpdateContactBirthDateArgs } from "@/core/api/graphql/types";

export async function updateContactBirthDate(command: InputUpdateContactBirthDateType): Promise<void> {
  await graphqlClient.mutate<Required<Pick<Mutations, "updateContactBirthDate">>, MutationsUpdateContactBirthDateArgs>({
    mutation: mutationDocument,
    variables: { command },
  });
}
